import React, { Component } from 'react';
import { Icon } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import LoginForm from '../../components/forms/login/LoginForm';
import { withLoginHandler } from '../providers/LoginFormHandler';


const StyledLoginFormWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    margin: 0 auto;

    & a {
        margin-top: 24px;
    }
`;

class LoginFormContainer extends Component {
    render() {
        return (
            <StyledLoginFormWrapper>
                <LoginForm {...this.props} />
                <Link to="/">
                    <Icon type="arrow-left" />
                    { ' Return to Booking Form' }
                </Link>
            </StyledLoginFormWrapper>
        );
    }
}

export default withLoginHandler(LoginFormContainer);
